export default __webpack_public_path__ + "static/media/copyIcon.6ede77e7.svg";